"use client";

import { buttonVariants } from "@packages/components/ui/Button";
import { cn } from "@packages/lib/utils";
import { VariantProps } from "class-variance-authority";
import React from "react";

type SmoothScrollLinkProps = React.ComponentProps<"a"> & {
  targetId: string;
  variant?: VariantProps<typeof buttonVariants>["variant"];
  size?: VariantProps<typeof buttonVariants>["size"];
};

export default function SmoothScrollLink({
  targetId,
  children,
  className,
  variant = "default",
  size = "default",
  ...props
}: SmoothScrollLinkProps) {
  return (
    <a
      href={`#${targetId}`}
      onClick={(e) => {
        e.preventDefault();
        document
          .getElementById(targetId)
          ?.scrollIntoView({ behavior: "smooth" });
      }}
      className={cn(buttonVariants({ variant, size }), className)}
      {...props}
    >
      <span className="inline-flex max-w-full items-center gap-2 truncate">
        {children}
      </span>
    </a>
  );
}
